<div class="custom-select-trigger" (click)="open($event)" (keydown.enter)="open($event)">
  @if(label())
  {
  <ion-label class="label">{{ label() }}</ion-label>
  }

  <!--  Error message -->
  @if (isInvalidInput() && errorMessage()) {
  <ion-text class="d-block text-danger-accent fw-normal">
    {{ errorMessage() }}
  </ion-text>
  }
  <div class="d-flex align-items-center">
    <div [ngClass]="customClass()"
      class="selected-value borderBoxBase w-100 d-flex align-items-center justify-content-between text-truncate"
      [class.borderBox]="isValidInput()" [class.borderErrorBox]="isInvalidInput()" [class.select-placeholder]="!value">
      <span class="selected-label text-truncate">
        {{ selectedLabel() || placeholder() }}
      </span>
      <div class="select-arrow">
        <div class="select-arrow-inner"></div>
      </div>
    </div>
    @if(showSuffixIcon() && suffixIconPath()){
      <ion-icon class="mx-2" [src]="suffixIconPath()" [attr.width]="iconSize()" [attr.height]="iconSize()"
      (click)="onIconClick($event)" (keydown.enter)="onIconClick($event)">
    </ion-icon>
    }
  </div>

</div>

<ion-popover [isOpen]="isOpen" [event]="popoverEvent" cssClass="custom-select-popover" backdropDismiss="true"
  (didDismiss)="close()">
  <ng-template>
    <ion-content>
      @if (options().length === 0) {
      <div class="empty-spacer"></div>
      }
      @else {
      <ion-radio-group [value]="value" (ionChange)="select($event)">
        <ion-list class="ion-no-padding">
          @for (option of options(); track option.value) {
          <ion-item lass="ion-no-padding" [ngClass]="listCustomClass()">
            <ion-radio mode="md" [value]="option.value" labelPlacement="start">
              {{ option.label }}
            </ion-radio>
          </ion-item>
          }
        </ion-list>
      </ion-radio-group>
      }
    </ion-content>
  </ng-template>
</ion-popover>